
import { Base } from '../../components/base-component';

import { AnalyticsService } from '../../services/analytics.service';

import './form-item-employer-value-banking.component.scss';

export class FormItemEmployerValueBanking extends Base {

	form: HTMLFormElement;
	submitBtn: Element;
	provinceSelect: HTMLFormElement;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-employer-value-banking__button');
		this.provinceSelect = this.form.querySelector('select[name=province]');
	}

	bindEvents() {
		
		this.submitBtn.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select, textarea');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		});

		if (this.provinceSelect) {
			this.provinceSelect.addEventListener('change', (event) => {
				this.selectProvinceEmail(event, this.form);
			});
		}
	}

	selectProvinceEmail(event, form: HTMLFormElement) {

		let provinceValue = event.currentTarget.value;

		let email = form.querySelector("input[name=email]") as HTMLFormElement;
		let recipient = form.querySelector("input[name=recipient]") as HTMLFormElement;

		//Select Email Address to send application too depending on the selected province
		let selectedProvince = provinceValue.toUpperCase();
		let provinceEmail = '';

		switch(selectedProvince) {
			case "GAUTENG" : {
				provinceEmail = 'EVBGP@standardbank.co.za';
				break;
			}
			case "EASTERN CAPE" : {
				provinceEmail = 'EVBEC@standardbank.co.za';
				break;
			}
			case "FREE STATE" : {
				provinceEmail = 'EVBFS@standardbank.co.za';
				break;
			}
			case "KWAZULU-NATAL" : {
				provinceEmail = 'evb@standardbank.co.za';
				break;
			}
			case "LIMPOPO" : {
				provinceEmail = 'EVBLP@standardbank.co.za';
				break;
			}
			case "MPUMALANGA" : {
				provinceEmail = 'EVBMP@standardbank.co.za';
				break;
			}
			case "NORTH WEST" : {
				provinceEmail = 'EVBNW@standardbank.co.za';
				break;
			}
			case "NORTHERN CAPE" : {
				provinceEmail = 'EVBNC@standardbank.co.za';
				break;
			}
			case "WESTERN CAPE" : {
				provinceEmail = 'EVBWC@standardbank.co.za';
				break;
			}
			default : {
				provinceEmail = '';
				break;
			}
		}

		if (provinceEmail != '') {
			if (email) {
				email.value = provinceEmail;
			}
			if (recipient) {
				recipient.value = provinceEmail;
			}
		}
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {
		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');


		let postData = '';

		let serviceType : any = form.querySelector("input[name=serviceType]");
		if (serviceType) {
			postData += 'service-type=' + serviceType.value;
		}
		let product: any = form.querySelector("input[name=product]");
		if (product) {
			postData += '&product=' + product.value;
		}
		let email: any = form.querySelector("input[name=email]");
		if (email) {
			postData += '&email=' + email.value;
		}
		let recipient: any = form.querySelector("input[name=recipient]");
		if (recipient) {
			postData += '&recipient=' + recipient.value;
		}
		let subject: any =form.querySelector("input[name=subject]");
		if (subject) {
			postData += '&subject=' + subject.value;
		}
		let description : any = form.querySelector("input[name=description]");
		if (description) {
			postData += '&description=' + description.value;
		}
		let redirect: any =form.querySelector("input[name=redirect]");
		if (redirect) {
			postData += '&redirect=' + redirect.value;
		}
		let _firstName: any = this.form.querySelector('input[name=firstName]');
		if (_firstName) {
			postData += '&firstname=' + _firstName.value;
		}
		let _lastName: any = this.form.querySelector('input[name=lastName]');
		if (_lastName) {
			postData += '&surname=' + _lastName.value;
		}
		let _phoneNumber: any = this.form.querySelector('input[name=phoneNumber]');
		if (_phoneNumber) {
			postData += '&contactNo=' + _phoneNumber.value;
		}
		let _email: any = this.form.querySelector('input[name=emailAddress]');
		if (_email) {
			postData += '&emailAddress=' + _email.value;
		}
		let _province: any = this.form.querySelector('select[name=province]');
		if (_province) {
			postData += '&province=' + _province.value;
		}
		let _cityTown: any = this.form.querySelector('input[name=cityTown]');
		if (_cityTown) {
			postData += '&cityTown=' + _cityTown.value;
		}
		let _isStandardBankCustomer: any = this.form.querySelector('select[name=isStandardBankCustomer]');
		if (_isStandardBankCustomer) {
			postData += '&existing-customer=' + _isStandardBankCustomer.value;
		}
		let _canContactCustomer: any = this.form.querySelector('select[name=canContactCustomer]');
		if (_canContactCustomer) {
			postData += '&canContactCustomer=' + _canContactCustomer.value;
		}
		let _interests: any = this.form.querySelector('textarea[name=interests]');
		if (_interests) {
			postData += '&interests=' + _interests.value;
		}
		
		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(function (response) {
			//Always show success message / no response from server (sending email)
			analyticsService.dtmFormComplete('complete', response.code);
			loader.classList.remove('active');
			thankyou.classList.add('active');
			success.classList.add('active');
			error.classList.add('hidden');
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-employer-value-banking/form-item-employer-value-banking.component.ts